import _ from 'lodash';
import axios from 'axios';
import { PROSODY_BASE_URL, NODE_ENV, TEST_SERVER_AUTH, WEBAPP_BASE_URL, ACCESS_TOKEN } from 'config';
export const _request = (path, method = 'GET', options = {}, token = false) => {
    let access_token = localStorage.getItem('11S_TOKEN');
    if (token && !access_token)
        access_token = localStorage.getItem('11S_TOKEN') || ACCESS_TOKEN;
    return axios({
        baseURL: options.baseURL || WEBAPP_BASE_URL,
        url: path,
        method,
        data: options.body,
        params: { access_token, ...options.queryParams },
        headers: {
            ...(NODE_ENV === 'dev' && TEST_SERVER_AUTH && { Authorization: TEST_SERVER_AUTH }),
            ...(!options.fileUploading && options.headers),
        },
    });
};
export const getInvitableUsers = async (token) => await _request(`/vmeet/invite_user_list.json`, 'GET', {
    queryParams: { access_token: token },
});
export const callUser = async (
// token: string,
callee_user_id, room_id, original_call_id, messageText) => await _request('/vmeet/invite_user.json', 'POST', {
    body: { callee_user_id, room_id, original_call_id, invite_message: messageText },
    // queryParams: { access_token: token },
});
export const cancelCall = async (token, call_id, temporary_token) => await _request('/vmeet/cancel_invite.json', 'POST', {
    body: { temporary_token, call_id },
    queryParams: { access_token: token },
});
export const timedoutCall = async (call_id, temporary_token) => await _request('/vmeet/timedout_invite.json', 'POST', {
    body: { temporary_token, call_id },
});
export const updateRoomConfig = async (knocking) => await _request('/vmeet/update_room_config.json', 'PUT', {
    queryParams: {
        roomId: window.APP.room.id,
        organizationId: window.APP.room.organisation_id,
        knocking,
    },
});
export const getUser = async (token) => await _request('/vmeet/me.json', 'GET', {
    queryParams: { access_token: token },
});
// await _request('/api/users/me', 'POST', {
//   body: { token },
// });
export const updateUserDiagnostic = async (diagnosticData) => {
    try {
        const { id, audio_bit_rate_upload, audio_bit_rate_download, video_bit_rate_upload, video_bit_rate_download, region, meeting_id, token, browser_name, browser_version, browser_os, } = diagnosticData;
        await _request('/vmeet/participant_diagnostic', 'POST', {
            body: {
                id: id,
                meeting_id: meeting_id,
                meeting_participant: {
                    id,
                    audio_bit_rate_upload,
                    video_bit_rate_upload,
                    audio_bit_rate_download,
                    video_bit_rate_download,
                    region,
                    meeting_id,
                    browser_name,
                    browser_version,
                    browser_os,
                },
            },
        }, true);
    }
    catch (err) {
        // Silently fail - diagnostic updates are non-critical
        // Log only in development to avoid console spam
        if (process.env.NODE_ENV === 'development') {
            console.warn('Failed to update user diagnostic:', {
                error: err?.message,
                status: err?.response?.status,
                meeting_id: diagnosticData?.meeting_id
            });
        }
    }
};
export const getUserProfilePhoto = async (token, email) => await _request('/vmeet/profile_photo.json', 'GET', {
    queryParams: { access_token: token, email },
});
// ! Changed order of arguments
export const getRoom = async (roomSlug, orgSlug) => await _request('/vmeet/check_room.json', 'GET', {
    // await _request('/api/room/check', 'GET', {
    queryParams: _.omitBy({
        organisation: orgSlug,
        room_name: roomSlug,
    }, _.isNil),
});
export const getConferenceOptions = async (room_id) => await _request('/vmeet/get_conference_options', 'GET', {
    queryParams: _.omitBy({
        room_id: room_id,
    }, _.isNil),
});
export const isModerator = async (roomId, email) => 
// await _request('/api/room/is_moderator', 'POST', {
//   body: {
//     email,
//     room_id: roomId,
//   },
// });
await _request('/vmeet/is_moderator.json', 'GET', {
    queryParams: {
        email,
        room_id: roomId,
    },
});
export const sendLog = async (data) => {
    // await _request('/logging', 'POST', {
    //   body: data,
    // });
};
// ! This changed the order of arguments
export const checkMeetingIsStarted = async (roomSlug, orgSlug) => await _request('/room', 'GET', {
    baseURL: PROSODY_BASE_URL,
    queryParams: {
        org_slug: orgSlug,
        room_slug: roomSlug,
    },
});
export const getBlockedExtension = async () => await _request('/api/fileUpload/black_list_extensions', 'GET');
export const uploadFile = async (meetingAttachment) => await _request('/api/vmeet/meeting_attachments', 'POST', {
    body: meetingAttachment,
});
export const hideMeeting = async (data) => {
    const queryParams = _.omitBy(data, _.isNil);
    // Format the URL with the id from the queryParams
    const url = `/api/vmeet/meetings/${queryParams.id}/hide`;
    return await _request(url, 'POST', {
        queryParams: _.omitBy(data, _.isNil),
    });
};
export const startMeetingAudit = async (data) => {
    const queryParams = _.omitBy(data, _.isNil);
    const url = `/api/vmeet/meetings/${queryParams.id}/start_auditing`;
    return await _request(url, 'POST', {
        body: data,
    });
};
export const endMeetingAudit = async (data) => {
    const queryParams = _.omitBy(data, _.isNil);
    const url = `/api/vmeet/meetings/${queryParams.id}/end_auditing`;
    return await _request(url, 'POST', {
        body: data,
    });
};
export const createNote = async (data) => {
    return await _request('/api/vmeet/meeting_audit_notes', 'POST', {
        body: data,
    });
};
export const updateNote = async (data) => {
    const queryParams = _.omitBy(data, _.isNil);
    return await _request(`/api/vmeet/meeting_audit_notes/${queryParams.id}`, 'PUT', {
        body: data,
    });
};
export const deleteNote = async (data) => {
    const queryParams = _.omitBy(data, _.isNil);
    return await _request(`/api/vmeet/meeting_audit_notes/${queryParams.id}`, 'DELETE');
};
export const fetchNote = async (data) => {
    return await _request('/api/vmeet/meeting_audit_notes', 'GET', {
        body: data,
    });
};
